import React, { FC } from 'react'
import { useLoading } from '../../../Provider/LoadingProvider'
import { createWorker, updateWorker } from '../../../services/worker'
import { Worker, WorkerCreate } from '../../../types/worker'
import DynamicForm from '../../Form/DynamicForm'
import { workerFormConfig } from './Columns'
import './style.scss'
import { useAuth } from '../../../Provider/AuthProvider'
import {} from '../../../utils/utils'

const FormWorker: FC<{
  onSubmit: () => void
  residentId: string
  initialValue?: Worker
}> = ({ onSubmit, residentId, initialValue }) => {
  const { startLoading, stopLoading } = useLoading()
  const { user } = useAuth()
  const handleSubmit = async (formData: WorkerCreate) => {
    try {
      startLoading()
      const data = new FormData()
      Object.entries({
        name: formData.name,
        lastName: formData.lastName,
        phoneNumber: formData.phoneNumber,
        photo: formData.photo,
        DNI_A: formData.DNI_A,
        DNI_B: formData.DNI_B,
        residentId,
        clientId: user?.clientId as string
      }).forEach(([key, value]) => {
        data.append(key, value)
      })

      if (initialValue) {
        await updateWorker(initialValue.id, data)
      } else {
        await createWorker(data)
      }

      onSubmit()
    } catch (error) {
      console.error(error)
    } finally {
      stopLoading()
    }
  }

  return (
    <div className='newDelegateResidentForm'>
      <h2>Nuevo trabajador</h2>
      <DynamicForm
        initialValues={initialValue}
        formConfig={workerFormConfig}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default FormWorker
